import { Time } from '/@/components/Time';
import { Plugin } from '@vue/runtime-dom';

const Dtime = ({ sortBy, record, t }) => {
  switch (sortBy?.sortVo?.orderBy) {
    case 'updateTime':
      return (
        <span>
          <Time value={record.updateTime ?? record.createTime} />
          {t ? t('更新') : '更新'}
        </span>
      );
    case 'createTime':
    default:
      return (
        <span>
          <Time value={record.createTime} />
          {t ? t('创建') : '创建'}
        </span>
      );
  }
};

export const DTime: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DTime', Dtime);
  },
};
